<div class="container">
  <mat-card class="form-card brand-neutral-white-card bgc-glass" appearance="outlined" appearance="outlined">
    <mat-card-header>
      <mat-card-title>Enter your details to create your personalized video</mat-card-title>
      <mat-card-subtitle>NOTE: This does not register or create a Genesys or Okta User Account.</mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <mat-form-field appearance="outline">
          <mat-label>First Name</mat-label>
          <input matInput formControlName="firstName" required />
          @if (form.get('firstName')?.hasError('required')) {
            <mat-error> First name is required </mat-error>
          }
          @if (form.get('firstName')?.hasError('minlength')) {
            <mat-error> First name is too short </mat-error>
          }
          @if (form.get('firstName')?.hasError('maxlength')) {
            <mat-error> First name is too long </mat-error>
          }
          @if (form.get('firstName')?.hasError('containsScript')) {
            <mat-error> Invalid characters detected </mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Last Name</mat-label>
          <input matInput formControlName="lastName" required />
          @if (form.get('lastName')?.hasError('required')) {
            <mat-error> Last name is required </mat-error>
          }
          @if (form.get('lastName')?.hasError('minlength')) {
            <mat-error> Last name is too short </mat-error>
          }
          @if (form.get('lastName')?.hasError('maxlength')) {
            <mat-error> Last name is too long </mat-error>
          }
          @if (form.get('lastName')?.hasError('containsScript')) {
            <mat-error> Invalid characters detected </mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Email</mat-label>
          <input matInput type="email" formControlName="email" required />
          @if (form.get('email')?.hasError('required')) {
            <mat-error> Email is required </mat-error>
          }
          @if (form.get('email')?.hasError('email')) {
            <mat-error> Please enter a valid email </mat-error>
          }
          @if (form.get('email')?.hasError('maxlength')) {
            <mat-error> Email is too long </mat-error>
          }
          @if (form.get('email')?.hasError('containsScript')) {
            <mat-error> Invalid characters detected </mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Company</mat-label>
          <input matInput formControlName="company" required />
          @if (form.get('company')?.hasError('required')) {
            <mat-error> Company is required </mat-error>
          }
          @if (form.get('company')?.hasError('minlength')) {
            <mat-error> Company is too short </mat-error>
          }
          @if (form.get('company')?.hasError('maxlength')) {
            <mat-error> Company name is too long </mat-error>
          }
          @if (form.get('company')?.hasError('containsScript')) {
            <mat-error> Invalid characters detected </mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Job Title</mat-label>
          <mat-select formControlName="title" required>
            @for (role of roleTypes; track role) {
              <mat-option [value]="role">
                {{ role }}
              </mat-option>
            }
          </mat-select>
          @if (form.get('title')?.hasError('required')) {
            <mat-error> Title is required </mat-error>
          }
        </mat-form-field>

        <mat-card-actions>
          <button class="submit" type="submit" [disabled]="form.invalid"> Watch Video </button>
          <button type="button" class="outline" (click)="onCancel()"> Cancel </button>
        </mat-card-actions>
      </form>
    </mat-card-content>
  </mat-card>
</div>
